import { Link } from "react-router-dom";
import { useStore } from "effector-react";

import ARROWLEFT from "../../../assets/images/NavMenu/VectorLeft.svg";
import ARROWRIGHT from "../../../assets/images/NavMenu/VectorRight.svg";
import VideoImage from "../../../assets/images/NavMenu/VideoImage.png";
import PhotoImage from "../../../assets/images/NavMenu/PhotoImage.png";
import ButtonPlay from "../../../assets/images/NavMenu/PlayButton.svg";
import Button2D from "../../../assets/images/NavMenu/2DButton.svg";
import Button3D from "../../../assets/images/NavMenu/3DButton.svg";
import { useTranslation } from "react-i18next";

import { $openModel, $openVideo } from "../../GuideButtons/logic/GuideLogic";

import "../style/navmenu.css";
import { Tooltip } from "@mui/material";

function detectMob() {
  return window.innerWidth <= 800 || window.innerHeight <= 600;
}

interface INavMenu {
  nextUrl: string;
  backUrl: string;
  visibleFlag?: string;
}

export const NavMenu = ({ nextUrl, backUrl, visibleFlag }: INavMenu) => {
  const openVideoStore = useStore($openVideo);
  const openModelStore = useStore($openModel);
  const { t } = useTranslation();
  return (
    <div
      className="NavBars"
      style={
        visibleFlag === "/pwa/model" ? { background: "rgb(236,236,236)" } : {}
      }
    >
      <Link to={backUrl}>
        <Tooltip
          title={
            visibleFlag === "/pwa/photo"
              ? t("Nav.There.photo")
              : visibleFlag === "/pwa/video"
              ? t("Nav.There.video")
              : visibleFlag === "/pwa/model"
              ? t("Nav.There.model")
              : ""
          }
          children={
            <button
              className="button_next_navmen"
              style={{
                textAlign: "center",
                zIndex: 3,
                height: "5vh",
                width: "5vw",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={ARROWLEFT}
                style={{ background: "50% 50% no-repeat" }}
                alt=""
              />
            </button>
          }
        />
      </Link>
      <Link to="/pwa/photo">
        <button
          className={
            visibleFlag === "/pwa/photo"
              ? "crop1 button_next_navmen borderNavMen"
              : "crop1 visiblBlock button_next_navmen borderNavMen"
          }
        >
          <div className="icon_2d">
            <img src={Button2D} style={{ height: "100%" }} alt="" />
          </div>
          <img
            src={PhotoImage}
            className="img_nammen"
            style={{ position: "unset" }}
            alt=""
          />
        </button>
      </Link>
      {openVideoStore ? (
        <Link to="/pwa/video">
          <button
            className={
              visibleFlag === "/pwa/video"
                ? "crop2 button_next_navmen borderNavMen"
                : "crop2 visiblBlock button_next_navmen borderNavMen"
            }
          >
            <div
              className="icon_2d"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <img
                src={ButtonPlay}
                style={{
                  height: "100%",
                  position: "absolute",
                  top: 0,
                  left: 0,
                }}
                alt=""
              />
            </div>
            <img src={VideoImage} className="img_nammen" alt="" />
          </button>
        </Link>
      ) : null}
      {openModelStore ? (
        <Link to="/pwa/model">
          <button
            className={
              visibleFlag === "/pwa/model"
                ? "crop2  button_next_navmen borderNavMen"
                : "crop2 visiblBlock button_next_navmen borderNavMen"
            }
          >
            <div className="icon_2d">
              <img src={Button3D} style={{ height: "100%" }} alt="" />
            </div>
            <img src={VideoImage} className="img_nammen" alt="" />
          </button>
        </Link>
      ) : null}
      {visibleFlag !== "/pwa/model" ? (
        (visibleFlag === "/pwa/photo" && openVideoStore) ||
        (visibleFlag === "/pwa/video" && openModelStore) ? (
          <Link to={nextUrl}>
            <Tooltip
              title={
                !detectMob() ? (
                  visibleFlag === "/pwa/photo" ? (
                    t("Nav.Back.photo")
                  ) : visibleFlag === "/pwa/video" ? (
                    t("Nav.Back.video")
                  ) : (
                    ""
                  )
                ) : (
                  <></>
                )
              }
              children={
                <button
                  className="button_next_navmen button_next_navmen_adpt"
                  style={{
                    zIndex: 3,
                    height: "5vh",

                    width: "5vw",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img src={ARROWRIGHT} alt="" />
                </button>
              }
            />
          </Link>
        ) : (
          <div></div>
        )
      ) : (
        <div></div>
      )}
    </div>
  );
};
